import supabase from '../lib/supabaseClient';

const todayISO = () => new Date().toISOString().slice(0, 10);

export const fetchHabitsWithLogs = async (userId) => {
  const { data: habits, error: habitsError } = await supabase
    .from('habits')
    .select('*')
    .eq('user_id', userId)
    .order('created_at', { ascending: true });

  if (habitsError) {
    throw habitsError;
  }

  const { data: logs, error: logsError } = await supabase
    .from('habit_logs')
    .select('*')
    .eq('user_id', userId)
    .order('logged_on', { ascending: false })
    .order('created_at', { ascending: false });

  if (logsError) {
    throw logsError;
  }

  return {
    habits: habits ?? [],
    logs: logs ?? [],
  };
};

export const upsertHabitLog = async ({ habitId, userId, status = 'completed', loggedOn = todayISO(), note = null }) => {
  const { data: existing, error: fetchError } = await supabase
    .from('habit_logs')
    .select('id')
    .eq('habit_id', habitId)
    .eq('user_id', userId)
    .eq('logged_on', loggedOn)
    .maybeSingle();

  if (fetchError && fetchError.code !== 'PGRST116') {
    throw fetchError;
  }

  if (existing?.id) {
    const { data, error } = await supabase
      .from('habit_logs')
      .update({ status, note })
      .eq('id', existing.id)
      .select()
      .single();

    if (error) {
      throw error;
    }

    return data;
  }

  const { data, error } = await supabase
    .from('habit_logs')
    .insert({
      habit_id: habitId,
      user_id: userId,
      status,
      note,
      logged_on: loggedOn,
    })
    .select()
    .single();

  if (error) {
    throw error;
  }

  return data;
};

export const deleteHabitLog = async ({ habitId, userId, loggedOn = todayISO() }) => {
  const { error } = await supabase
    .from('habit_logs')
    .delete()
    .eq('habit_id', habitId)
    .eq('user_id', userId)
    .eq('logged_on', loggedOn);

  if (error) {
    throw error;
  }
};

export const createHabit = async (habit) => {
  const { data, error } = await supabase.from('habits').insert(habit).select().single();

  if (error) {
    throw error;
  }

  return data;
};

export const updateHabit = async (id, updates) => {
  const { data, error } = await supabase.from('habits').update(updates).eq('id', id).select().single();

  if (error) {
    throw error;
  }

  return data;
};

export const deleteHabit = async (id) => {
  const { error } = await supabase.from('habits').delete().eq('id', id);

  if (error) {
    throw error;
  }
};
